import { memo } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { MODAL_IDS, ModalItem, ModalSimple, Seo, useModal } from 'components'
import { useOnMount } from 'hooks'
import { useGetContactListQuery, useUpdateContactMutation } from 'modules/contact/api'
import { ContactUpdateForm } from 'modules/contact/components'

import { contactDetailRoute, contactDetailUpdateRoute, contactRoute } from '../../routes'

const ContactUpdate = memo(function ContactUpdate() {
  const navigate = useNavigate()
  const { id } = contactDetailUpdateRoute.useParams()

  const searchParams = contactDetailUpdateRoute.useSearch()

  const { refetch } = useGetContactListQuery('')
  const [updateContact, { isLoading: isUpdating }] = useUpdateContactMutation()

  const { openModal, closeModal } = useModal()

  const onClose = () => {
    closeModal(MODAL_IDS.UpdateContact)
    const from = searchParams.from || ''
    if (from) {
      navigate({ to: from })
    } else {
      navigate(contactRoute)
    }
  }

  const handleComplete = () => {
    navigate({ to: contactDetailRoute.to, params: { id } })
  }

  useOnMount(() => openModal(MODAL_IDS.UpdateContact))

  return (
    <>
      <Seo
        description="Страница для изменения данных контакта, добавленном в сервис QP5 Express: контактное лицо, номер телефона для связи."
        title="Редактирование контакта – сборные перевозки QP5 Express"
      />
      <ModalItem id={MODAL_IDS.UpdateContact}>
        <ModalSimple id={MODAL_IDS.UpdateContact} onClose={onClose} title="Редактирование контакта">
          <ContactUpdateForm
            isUpdating={isUpdating}
            onClose={onClose}
            onComplete={handleComplete}
            refetch={refetch}
            updateContact={updateContact}
          />
        </ModalSimple>
      </ModalItem>
    </>
  )
})

export default ContactUpdate
